<template>
  <appTable
    v-if="shouldRenderConfig && !getBundleIsActive"
    v-show="alwaysShow || getShowUpload"
    :tableName="name"
    :tableClass="getClassName"
  >
    <appUploadContainer :alwaysShow="alwaysShow"></appUploadContainer>
    <appPersonalizationButton
      v-if="getUploadPersonalizationOneProduct"
      class="matrix_personzalizeButtonMain"
    ></appPersonalizationButton>
  </appTable>
</template>
<script>
import { useConfigStore } from "@/stores/modules/config";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useBundleStore } from "@/stores/modules/bundle";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useBundleStore, ["getBundleIsActive"]),
    ...mapState(useConfigStore, ["getShowUpload"]),
    ...mapState(useWebproductStore, ["getUploadPersonalizationOneProduct"]),
    name: () => {
      return "Upload";
    }
  },
  props: ["alwaysShow"]
};
</script>
